export const isValidEmailOnInput = (elementId) => {
	const email = document.getElementById(elementId).value;
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
};

export const isInputEmpty = (elementId) => {
	const element = document.getElementById(elementId);
	if (!element) {
		return false;
	}

	const name = element.value;
	return name.length === 0;
};
